<template v-slot:default="{ isActive }">
  <v-dialog
    v-model="dialog"
    width="60rem"
    class="layer-popup"
    scrollable
  >
    <v-card>
      <!--content-->
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="pop-title">{{t('message.correctiveActionDetails')}}</div>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click.stop="dialog = false"
        ></v-btn>
      </v-card-title>
      <!--content-->
      <v-card-text>
        <Textarea :placeholder="t('message.correctiveActionDetails')" v-model="comment"/>
        <div class="form-group col-ty">
          <!--form-row-->
          <div class="form-row ty10">
            <div class="inp-comment v1">
              <div class="img-upload">
                <v-file-input
                  label="File input w/ chips"
                  chips
                  multiple
                  accept="image/png, image/jpeg"
                  @change="onChangeImg"
                ></v-file-input>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <!--버튼-->
      <v-card-actions class="d-flex justify-end pop-bottom-bg"><!--pop-bottom-bg-->
        <c-btn02 :btnText="t('message.cancel')" @click="dialog=false"/>
        <c-btn01 :btnText="t('message.save')" @click="onClickConfirm"/>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n';
import utils from "@/common/Utils";
import TimelineService from "@/services/timeline.service";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
const { t } = useI18n();

const props = defineProps(['popTitle'])
const emit = defineEmits(['close', 'confirm'])
const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
let file = null
const comment = ref('')
const snackbar = ref(false)
const snackText = ref('')

//hook
onUpdated(() => {
  if(dialog.value)
    comment.value = ''
})

//function
function onChangeImg(e: Event){
  file = (e.target as HTMLInputElement).files[0];
}

function onClickConfirm(){
  if(utils.isEmpty(comment.value) && !file){
    snackText.value = t('message.enterTextOrAttachImage')
    snackbar.value = true
    return
  }

  const idx = storeRef.timelineIdx.value
  const formData = new FormData();
  if(file)
    formData.append("file", file);
  formData.append("timelineIdx", idx);
  formData.append("comment", comment.value);
  formData.append('companyIdx', localStorage.getItem('companyIdx'));

  TimelineService.insertTimelineComment(formData).then(
    (response) => {
      if(response.success) {
        comment.value = ''
        file = null
        emit('confirm', comment.value)
        dialog.value = false
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}
</script>


<style lang="scss">

</style>
